import React from 'react';
import { Account, TaskDefinitionSummary } from '../../types';
import { TemplateUploadModal } from '../TemplateUploadModal';
import { TemplateSettingsModal } from '../TemplateSettingsModal';
import { PatientModal } from '../PatientModal';

interface UploaderModalsProps {
  isManageTemplatesModalVisible: boolean;
  onManageTemplatesClose: () => void;
  onTemplateAdded: () => void;
  currentAccount: Account;
  onAccountUpdated: (account: Account) => void;
  showTemplateSettingsModal: boolean;
  onTemplateSettingsClose: () => void;
  selectedTemplate: string;
  templates: TaskDefinitionSummary[];
  showAddTemplateModal: boolean;
  onAddTemplateClose: () => void;
  showPatientModal: boolean;
  onPatientModalClose: () => void;
  onPatientAdded: (patient: any) => void;
}

export const UploaderModals: React.FC<UploaderModalsProps> = ({
  isManageTemplatesModalVisible,
  onManageTemplatesClose,
  onTemplateAdded,
  currentAccount,
  onAccountUpdated,
  showTemplateSettingsModal,
  onTemplateSettingsClose,
  selectedTemplate,
  templates,
  showAddTemplateModal,
  onAddTemplateClose,
  showPatientModal,
  onPatientModalClose,
  onPatientAdded,
}) => {
  return (
    <>
      {/* Manage Templates Modal */}
      <TemplateUploadModal
        isVisible={isManageTemplatesModalVisible}
        onClose={onManageTemplatesClose}
        onTemplateAdded={onTemplateAdded}
        currentAccount={currentAccount}
        onAccountUpdated={onAccountUpdated}
      />

      {/* Add Template Modal */}
      <TemplateUploadModal
        isVisible={showAddTemplateModal}
        onClose={onAddTemplateClose}
        onTemplateAdded={onTemplateAdded}
        currentAccount={currentAccount}
        onAccountUpdated={onAccountUpdated}
      />

      {/* Template Settings Modal */}
      {showTemplateSettingsModal && selectedTemplate && (
        <TemplateSettingsModal
          isVisible={showTemplateSettingsModal}
          onClose={onTemplateSettingsClose}
          template={templates.find(t => t.id === selectedTemplate)!}
        />
      )}

      {/* Patient Modal */}
      <PatientModal
        isVisible={showPatientModal}
        onClose={onPatientModalClose}
        onPatientAdded={onPatientAdded}
      />
    </>
  );
}; 